import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import store from './store';

const Collections = () => import(/* webpackChunkName: "collections" */ './components/Collections.vue');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: '/',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      component: Home,
      children: [
        {
          path: '',
          name: 'static-collections',
          meta: {
            title: 'Static collections | Custom Logo',
          },
          component: Collections,
        },
        {
          path: '/animated-collections',
          name: 'animated-collections',
          meta: {
            title: 'Animated collections | Custom Logo',
          },
          component: Collections,
        },
      ],
    },
    {
      path: '/collections/:url',
      name: 'collection',
      beforeEnter: (to, from, next) => {
        document.title = `${to.params.url.charAt(0).toUpperCase()}${to.params.url.slice(1).replace(/-/g, ' ')} | Custom logo`;
        next();
      },
      component: () => import(/* webpackChunkName: "collectionPage" */ './views/CollectionPage.vue'),
    },
    {
      path: '/upload',
      name: 'upload',
      meta: {
        title: 'Upload | Custom Logo',
      },
      component: () => import(/* webpackChunkName: "UploadPage" */ './views/UploadPage.vue'),
    },
    {
      path: '/about',
      name: 'about',
      meta: {
        title: 'About us | Custom Logo',
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/thank-you',
      name: 'thank-you',
      meta: {
        title: 'Thank You | Custom Logo',  
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Thankyou" */ './views/Thankyou.vue'),
    },
    {
      path: '/style-guide',
      name: 'style-guide',
      meta: {
        title: 'Style Guide',
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "styleGuide" */ './views/StyleGuide.vue'),
    },
    {
      path: '/contacts',
      name: 'contacts',
      meta: {
        title: 'Contact us | Custom Logo',
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "contacts" */ './views/Contacts.vue'),
    },
    {
      path: '/how-to-use',
      name: 'how-to-use',
      meta: {
        title: 'How to use | Custom Logo',
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "howToUse" */ './views/HowToUse.vue'),
    },
    {
      path: '/privacy',
      name: 'privacy',
      meta: {
        title: 'Privacy Policy | Custom Logo',
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "privacy" */ './views/Privacy.vue'),
    },
    {
      path: '/terms',
      name: 'terms',
      meta: {
        title: 'Terms of Use | Custom Logo',
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "terms" */ './views/Terms.vue'),
    },
    {
      path: '/404',
      name: '404',
      meta: {
        title: 'Not found | Custom Logo',
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "404" */ './views/404.vue'),
    },
    {
      path: '*',
      redirect: '404',
    },
  ],
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  store.dispatch('setPageStatus', false);

  if (from.name === 'animated-collections') {
    store.dispatch('setIsAnimated', true);
  } else {
    store.dispatch('setIsAnimated', false);
  }

  next();
});

export default router;
